function createModal($trigger, $) {
  const $iframe = $('#modal-frame');
  const $loader = $iframe.next('.loader');
  const $modal = $iframe.closest('.modal');
  const setHeight = () => {
    const { scrollHeight: height } = $iframe[0].contentWindow.document.querySelector('body');
    $iframe.css('height', `${height}px`);
    $iframe.attr('height', height);
  };

  // Set the modal's width
  let width = $trigger.data('width');
  if (width) {
    width -= 2;
    $iframe.css('width', `${width}px`);
    $iframe.attr('width', width);
  } else {
    $iframe.css('width', '100%');
    $iframe.attr('width', 930);
  }
  $iframe.attr('src', $trigger.attr('href'));

  // Dynamic height
  $(window).resize(setHeight);
  $iframe.on('load', () => {
    if ($iframe.attr('src')) {
      $loader.css('display', 'none');
      $iframe.show();
    }
    setHeight();
  });

  // Resetting state
  $modal.on('hidden.bs.modal', () => {
    $loader.css('display', '');
    $iframe.removeAttr('src');
  });
}

export default createModal;



// WEBPACK FOOTER //
// ./_common/scripts/modals.js